import type { PutLabelsRbacEnrolmentBody } from '@ipfabric/api-client/client/schemas';
import { useLoadingState } from '@ipfabric/ui-components/hooks/useLoadingState';
import { withLoadingIndicator } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import { useNotifications } from 'utils/hooks/useNotifications';
import { useSaveLabelEnrolment } from '../dataPoliciesApi';

export const useSaveEnrolment = (onSaved: () => void) => {
  const saveLabelEnrolment = useSaveLabelEnrolment();
  const { showNotification } = useNotifications();
  const [state, setState] = useLoadingState();

  const save = async (change: PutLabelsRbacEnrolmentBody) => {
    await withLoadingIndicator(setState)(() => saveLabelEnrolment(change));
    showNotification({ type: 'success', message: 'Enrolled labels saved' });
    onSaved();
  };

  return { save, saving: state === 'LOADING' };
};
